import { loadConfigAction, tipoAcessoAction } from './actions';

const INITIAL_STATE: ConfigState = {
  assessoriaName: 'Vazio',
  assessoriaPalette: '#3C50E0',
  corEscura: '',
  corEscuraSecundaria: '',
  homePageFontColor: '',
  homePageLinkColor: '',
  corDadosUsuario: '',
  corClara: '',
  corHeader: '',
  corFooter: '',
  assessoriaLogo: '',
  urlLogoSecundario: '',
  assessoriaImage: '',
  imagemCentralHome: '',
  imagemCentralMobile: '',
  termosUso: '',
  tipoAcesso: undefined,
  assessoriaTelephone: '',
  enderecoAssessoria: '',
  startBusinessDayAttendance: '',
  endBusinessDayAttendance: '',
  startSaturdayAttendance: '',
  endSaturdayAttendance: '',
  usaPix: '',
  usaCopiarLD: '',
  usaSMSLD: '',
  usaWhatsappLD: '',
  usaEmailLD: '',
  usaDownloadBoleto: '',
  usaPagamentoCartaoCredito: '',
  usaImprimirBoleto: '',
  mensagemBoleto: '',
  usaReceberLigacao: '',
  usaAgendarLigacao: '',
  usaLigarAgora: '',
  usaWhatsapp: '',
  usaEnviarMensagem: '',
  usaEnviarEmail: '',
  usarDataNascimento: '',
  useTerms: '',
  politicaPrivacidade: '',
  profileOmni: '',
  tempoExpiracaoToken: '',
  tituloSite: '',
  whatsappContact: '',
  whatsappMessage: '',
  enviaTokenSMS: '',
  enviaTokenWhatsapp: '',
  validacaoAcesso: '',
  favicon: '',
  gTagManager: '',
  usaBordaHomePageCpfInput: '',
  exibeFaq: '',
  textoFaq: '',
  mensagemCpfNaoEncontrado: '',
  radiusButton: '',
  nomeFont: '',
  linkFont: '',
  corFontFooter: '',
  radiusCards: '',
  radiusBotoesContato: '',
  textoMelhorOpcao: '',
  emailAssessoria: '',
};

export default function data(state = INITIAL_STATE, action: any) {
  switch (action.type) {
    case tipoAcessoAction:
      return {
        ...state,
        tipoAcesso: action.payload,
      };
    case loadConfigAction.success:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
}
